import { connect } from 'react-redux';
import { TrialMeterByDays } from '@studio/navigation';
import { Link } from 'react-router-dom';

import { selectTrialStatus } from 'next/entities/trial-status';
import { selectAccount } from 'next/entities/account';

const mapStateToProps = state => ({
  account: selectAccount(state),
  trialStatus: selectTrialStatus(state),
  Link,
});

export default connect(mapStateToProps)(TrialMeterByDays);
